@if(form) {
  <mat-form-field [formGroup]="form" appearance="outline" color="primary" class="input-field" [class]="this.className">
      @if (this.label) {
          <mat-label>{{this.label}}</mat-label>
      }
      <input #innerInput matInput [id]="this.key" [type]="this.type || 'text'" [formControlName]="this.key"
          [readonly]="this.readonly" [name]="this.key" [value]="this.value" (blur)="handleOnBlur($event)"
          [placeholder]="this.placeholder" (input)="handleOnInput($event)" (keypress)="handleEnterPress($event)"
          [errorStateMatcher]="errorStateMatcher" [libDynamicFollowSuffix]="this.showSuffix() ? this.suffix : ''"/>
        <ng-container matSuffix>
          <ng-content select="[suffix]"></ng-content>
        </ng-container>
        @let customError = getCustomError(control);
        @if (customError) {
            <mat-error>
                {{ customError }}
            </mat-error>
        }
        @let validationErrorMessage = getValidationErrors(control);
        @if (validationErrorMessage) {
            <mat-error>
                {{ validationErrorMessage }}
            </mat-error>
        }
      <mat-hint>{{ this.hint }}</mat-hint>
  </mat-form-field>
  } @else {
  <mat-form-field appearance="outline" color="primary" class="input-field" [class]="this.className">
      <mat-label>{{this.label}}</mat-label>
      <input #innerInput matInput [id]="this.key" [type]="this.type || 'text'" [name]="this.key" [value]="this.value"
        (blur)="handleOnBlur($event)" [placeholder]="this.placeholder" [errorStateMatcher]="errorStateMatcher" (keypress)="handleEnterPress($event)"/>
        <ng-container matSuffix>
            <ng-content select="[suffix]"></ng-content>
        </ng-container>
      <mat-hint>{{ this.hint }}</mat-hint>
  </mat-form-field>
  }